export default __webpack_public_path__ + "d0297bed72b8df8cbea88d4ee7d16b1e.png";